<template>
  <span class="stars">&starf;&starf;&starf;&starf;&starf;</span>
</template>

<script>
export default {
  name: 'Stars'
}
</script>

<style scoped>
.stars {
  color: #ffcb08;
  word-break: keep-all;
}
</style>
